import {ref} from 'vue';
import useVuelidate from '@vuelidate/core';
import {helpers, numeric, required} from '@vuelidate/validators';
import {vrm} from '../../modules/regitValidators';

enum CarWorthFormFields {
    'vrm' = 'vrm',
    'mileage' = 'mileage',
}
type FormInitialValues = { [key in CarWorthFormFields]: string }|undefined;

export default function useCarWorthForm(
    initialValues?: FormInitialValues,
) {
    const state = {
        carWorthVrm: ref( initialValues?.vrm || ''),
        carWorthMileage: ref( initialValues?.mileage || ''),
    };

    const v = useVuelidate({
        carWorthVrm: {
            required: helpers.withMessage('Please enter your reg plate', required),
            vrm: helpers.withMessage('The reg plate is not recognized', vrm),
        },
        carWorthMileage: {
            required: helpers.withMessage('Please enter your mileage', required),
            numeric,
        },
    }, state);

    async function submitForm(e: Event) {
        e.preventDefault();
        e.stopPropagation();

        const validationPassed = await v.value.$validate();
        if (validationPassed) {
            (document.getElementById('submit-valuation-form') as HTMLFormElement).submit();
        }
    }

    return {
        carWorthVrm: state.carWorthVrm,
        carWorthMileage: state.carWorthMileage,
        carWorthValidator: v,
        onCarWorthSubmit: submitForm,
    };
}
